import React from "react";

export default function CalendarDetails({ date, data, onClose }) {
  if (!date || !data) return null;

  return (
    <div
      className="
            fixed
            inset-0
            bg-black/60
            flex
            justify-end
            z-50
        "
    >
      <div
        className="
                w-full
                md:w-96
                bg-gray-950
                h-full
                p-6
                border-l
                border-gray-700
            "
      >
        <div
          className="
                    flex
                    justify-between
                    mb-6
                "
        >
          <h2
            className="
                        text-xl
                        font-bold
                        text-white
                    "
          >
            {date.toDateString()}
          </h2>

          <button onClick={onClose} className="text-gray-400 w-fit px-2 py-1">
            ✕
          </button>
        </div>

        <div className="space-y-4">
          <div
            className="
                        bg-gray-900
                        rounded-xl
                        p-4
                    "
          >
            <div className="text-gray-400 text-sm">Score</div>

            <div
              className="
                            text-3xl
                            font-bold
                            text-cyan-400
                        "
            >
              {data.averageScore}
            </div>
          </div>

          <div
            className="
                        bg-gray-900
                        rounded-xl
                        p-4
                    "
          >
            <div>
              😊 Mood:
              {data.averageMood}
            </div>

            <div>
              ⚡ Energy:
              {data.averageEnergy}
            </div>

            <div>
              ⏱ Duration:
              {data.duration} min
            </div>

            <div>
              📌 Activities:
              {data.activities}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
